<template>
  <svg
    width="34"
    height="41"
    viewBox="0 0 34 41"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9651 19.6257C12.8042 19.5479 9.52661 16.1482 9.59883 12.0485V8.66541C9.52661 4.58793 12.8042 1.18818 16.9096 1.11597C21.0705 1.19374 24.3481 4.59349 24.2759 8.69318V12.0652C24.337 16.1593 21.065 19.5479 16.9651 19.6257ZM16.9096 4.27129C14.6097 4.31573 12.7209 6.27114 12.7598 8.63208V12.0707C12.7153 14.4594 14.6041 16.4148 16.9651 16.4593C19.2706 16.4148 21.1538 14.4594 21.1094 12.0985V8.65985C21.1538 6.27114 19.2706 4.31573 16.9096 4.27129Z"
      :fill="color"
    />
    <path
      d="M3.63231 40.7353C3.49343 40.7353 3.34343 40.7242 3.19344 40.7076C2.73593 40.6482 2.29471 40.4988 1.89521 40.2681C1.49571 40.0373 1.14584 39.7298 0.865773 39.3632C0.293578 38.6188 0.0491451 37.6967 0.171362 36.769C1.36575 28.4696 8.57097 22.2256 16.9372 22.2256C25.3035 22.2256 32.5087 28.4696 33.6976 36.7523C33.7737 37.2896 33.723 37.8373 33.5493 38.3515C33.3757 38.8657 33.084 39.332 32.6976 39.7132C32.3726 40.0387 31.9863 40.2967 31.561 40.4721C31.1358 40.6475 30.68 40.737 30.2199 40.7353H3.63231ZM16.9372 25.3809C10.132 25.3809 4.27117 30.4583 3.30455 37.1967C3.28233 37.3689 3.41565 37.5467 3.61009 37.5689H30.2199C30.4144 37.5689 30.5699 37.4134 30.5699 37.2189C29.6033 30.4639 23.7425 25.3809 16.9372 25.3809Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "SinglePersonIcon",
  props: {
    color: {
      type: String,
      default: "#4A4A4A",
    },
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["small", "medium", "large", "xxlarge"].includes(value);
      },
    },
  },
};
</script>

<style scoped>
.st0 {
  fill: #619bc4;
}
.small {
  height: 16px;
  width: auto;
}
.medium {
  height: 24px;
  width: auto;
}
.large {
  height: 60px;
  width: auto;
}
.xxlarge {
  height: 84px;
  width: auto;
}
</style>
